<template>
  <div class="container">
    <div class="chat-container">
      <img src="../../assets/step5/chat_bg.jpg" class="chat-bg" alt="">
      <div class="detail-container">
        <div class="chat-window">
            TECENTRIQ<br/>
            Do you want to prescribe<br/>Tecentriq to your next mUC patient?
        </div><!-- chat window end sub -->
        <div class="chat-window chat-right">
            Physician<br/>
            <div class="checkbox-group">
              <input type="radio" v-model="dataRow.physician" value="Yes" name="c1" id="c1-1">
              <label for="c1-1">Yes</label>
            </div>
            <div class="checkbox-group">
              <input type="radio" v-model="dataRow.physician" value="No" name="c1" id="c1-2">
              <label for="c1-2">No</label>
            </div>
            <div class="checkbox-group">
              <input type="radio" v-model="dataRow.physician" value="I need more information" name="c1" id="c1-3">
              <label for="c1-3">I need more information</label>
            </div>
        </div><!-- chat window end sub -->
        <div class="chat-window-input">
          <input type="text" v-model="dataRow.name" placeholder="Enter Name">
          <input type="text" v-model="dataRow.hospital" placeholder="Enter Hospital">
        </div><!-- chat window input end sub -->
      </div><!-- detail container -->
    </div><!-- chat container end sub -->
    <div class="complete-container">
      <img src="../../assets/step5/complete.png" alt="">
      <div class="completeRadio">
        <input type="checkbox" @change="onSubmitData()" name="complete" class="hook" id="complete">
        <label for="complete" class="check-box"></label>
      </div>
    </div>
    <template>
      <router-link to="/step5-1" class="btn-prev el-icon-arrow-left"></router-link>
    </template>
    <!-- <pre v-html="preHtml"></pre> -->
  </div>
</template>

<script>
export default {
  name: 'page3',
  props: ['result', 'locationSrc'],
  data () {
    return {
      dataRow: {
        physician: '',
        name: '',
        hospital: ''
      },
      preHtml: ''
    }
  },
  methods: {
    onSubmitData: function () {
      var dataRow = this.dataRow
      if (dataRow.physician === '') {
        this.messageAlert('<span class="el-icon-warning" style="color:#F56C6C;"></span> 請選擇一個選項')
        $('.hook').prop('checked', false)
      } else if (dataRow.name === '') {
        this.messageAlert('<span class="el-icon-warning" style="color:#F56C6C;"></span> 請輸入你的名字')
        $('.hook').prop('checked', false)
      } else if (dataRow.hospital === '') {
        this.messageAlert('<span class="el-icon-warning" style="color:#F56C6C;"></span> 請輸入醫院名稱')
        $('.hook').prop('checked', false)
      } else {
        // 送出
        this.$emit('update:result', {'complete': dataRow})
        var locationSrc = this.locationSrc
        var resultData = this.sortOutData(this.result)
        var thisRouter = this.$router
        var pathFile = location.hostname === 'chance.pointup.com.tw' ? '' : 'chance/'

        var results = this.AjaxData(
          locationSrc + pathFile + 'api/addSurvey.php',
          'POST',
          'json',
          resultData
        )
        // console.log(locationSrc + pathFile + 'api/addSurvey.php')
        // this.preHtml = results
        // return
        if (results.errorcode === '0') {
          setTimeout(function () { thisRouter.push('/step5-3') }, 800)
        } else {
          $('.hook').prop('checked', false)
          this.messageAlert('系統發生錯誤，請通知系統人員')
        }
      }
    },
    sortOutData: function ($row) {
      console.log('sort', $row)
      var newData = {
        'complete': '',
        'step1-1': '',
        'step1-2': '',
        'step2-1': '',
        'step2-2': '',
        'step3-1': '',
        'step3-2': '',
        'step4-1': '',
        'step4-2': ''
      }
      for (let datas in $row) {
        newData[datas] = $row[datas]
      }
      return newData
    },
    messageAlert: function ($text = '沒有輸入提示文字') {
      this.$alert('<div class="messageBox">' + $text + '', {
        showConfirmButton: false,
        center: true,
        dangerouslyUseHTMLString: true
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .chat-container {
    width:80%;margin:auto;
    position:relative;
  }
  .chat-container .chat-bg {
    width:100%;
  }
  .chat-container .detail-container {
    width:87%;top:0;
    position:absolute;left:13%;
    height:100%;
  }
  .chat-container .detail-container .chat-window {
    background: #8fc31f;
    padding:20px 25px;width:70%;
    border-radius:10px;color:white;
    margin:10% auto;position:relative;
    font-size:20px;letter-spacing:.5pt;
  }
  .chat-container .detail-container .chat-window .checkbox-group {
    margin:10px 0;
  }
  .chat-container .detail-container .chat-window .checkbox-group label {
    display:block;cursor:pointer;
  }
  .chat-container .detail-container .chat-window .checkbox-group input[type="radio"]{
    display:none;
  }
  .chat-container .detail-container .chat-window .checkbox-group label:before {
    width:20px;height:20px;display:inline-block;vertical-align:middle;
    content:"";border:solid 2px white;margin-right:10px;
  }
  .chat-container .detail-container .chat-window .checkbox-group input[type="radio"]:checked + label:before {
    background:white;
  }
  .chat-container .detail-container .chat-window:before {
    background:url(../../assets/step5/chat-left.png) top left;
    content:"";display:block;height:30px;position:absolute;
    left:-30px;top:0px;width:40px;
  }
  .chat-container .detail-container .chat-window.chat-right:before {
    background:url(../../assets/step5/chat-right.png) top right;
    left:auto;right:-30px;
  }
  .chat-container .detail-container .chat-window-input {
    padding:20px 25px;background:#eeeeee;
    position:absolute;bottom:0;width:100%;
    box-sizing:border-box;
  }
  .chat-container .detail-container .chat-window-input input[type="text"]{
    display:block;outline:none;width:100%;
    padding:10px;background:white;border:none;
    margin:10px 0;font-size:18px;letter-spacing:.5pt;
    font-weight:normal;box-sizing:border-box;
  }
  .complete-container {
    padding:40px 0;text-align:right;
    width:80%;margin:auto;
  }
  .complete-container img {
    display:inline-block;width:100px;
    margin-right:10px;
  }
  .complete-container .completeRadio {
    display:inline-block;vertical-align:top;
    position:relative;
  }
  a[class*="btn-"]{
    background:#b6798e;color:white;
  }
  @media(max-width:750px){
    .chat-container {background:gray;}
    .chat-container .detail-container .chat-window {
      font-size:13px;padding: 5px 15px;margin:4% auto;
    }
    .chat-container .detail-container .chat-window .checkbox-group label:before {
      width:10px;height:10px;
    }
    .chat-container .detail-container .chat-window-input {
      padding:5px 25px;
    }
    .chat-container .detail-container .chat-window:before {
      left:-15px;width:22px;
    }
    .chat-container .detail-container .chat-window.chat-right:before {
      right:-15px;left:auto;
    }
    .chat-container .detail-container .chat-window-input input[type="text"] {
      font-size:15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/step5/page3.vue